import { executeRequest, Request } from '@jfs/network'
import { getOnboardRequestBody } from './../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const onBoardmerchant = (mobile: string, password: string, otp: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.onboardMerchant,
    method: 'POST',
    config: sitConfig(tokens),
    body: getOnboardRequestBody(mobile, otp, password),
  }
  return executeRequest(request).then((data) => {
    return data.data
  })
}

export { onBoardmerchant }
